import React from "react";
import Peer2PeerTable from "./Peer2PeerTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const Peer2PeerIndex = () => (
  <ReportProgramsPage
    TableComponent={Peer2PeerTable}
    loadingMessage="Loading peer to peer report..."
  />
);

export default Peer2PeerIndex;
